export { localesOptions } from '@rebound/shared-models/utils';

export const helpOptions = {
  returnPolicy: 'Return policy',
  faultyItem: 'Faulty item',
  support: 'Support',
};
